import { JfsFormData } from "../../../types";
import { Flow } from "./../../../components/content";
import { quoteSchema } from "./quoteSchema";

const CreateQuote = () => {
  const onSubmit = async (submitData: JfsFormData): Promise<boolean> => {
    alert("Submitted quote!");
    return true;
  };

  return (
    <Flow
      id="quotes-create"
      name="New quote"
      onSubmit={onSubmit}
      schema={quoteSchema}
    />
  );
};

export default CreateQuote;
